<!--Copyright Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

@if (!isDynamic) {
  <span class="token-picker-field-box" [ngClass]="{ 'extra-space': !getBrokenValidationRule() }">
    @if (showTokenTextBox) {
      <mat-form-field title="{{ lf_field_info.displayName }}" appearance="outline" class="lf-field">
        <input
          #tokenTarget
          matInput
          type="text"
          [formControl]="lf_field_form_control"
          title="{{ lf_field_form_control.value }}"
          (change)="onTimeValueChangedAsync()"
        />
      </mat-form-field>
    }
    @if (!showTokenTextBox) {
      <lfint-uni-date-time
        #tokenTarget
        class="lf-field"
        [config]="uniDateTimeConfig"
        [settings]="uniDateTimeSettings"
        (valueChangedEventHandler)="onUniDateOrTimeChanged($event)"
      >
      </lfint-uni-date-time>
    }
    <lfint-token-picker-component
      class="lf-field-token-picker"
      (tokenPicked)="onTimeTokenChosen($event)"
      [data]="lfFieldTokenData"
    >
    </lfint-token-picker-component>
  </span>
} @else {
  <lfint-dynamic-field-component
    ngDefaultControl
    [options]="dynamic_field_value_options"
    [formControl]="lf_field_form_control"
    [title]="lf_field_info.displayName"
    [fieldValidationErrorMsg]="fieldValidationErrorMsg"
    [getBrokenValidationRule]="getBrokenValidationRule.bind(this)"
    (valueChange)="onValueChanged()"
  >
  </lfint-dynamic-field-component>
}
@if (getBrokenValidationRule()) {
  <mat-error>{{ fieldValidationErrorMsg | async }}</mat-error>
}
